import type { IconDef } from '../types';

export const homeFilled: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M21.36 8.7475L15.36 3.2975C13.45 1.5675 10.54 1.5675 8.63 3.2975L2.64 8.7475C1.6 9.6975 1 11.0375 1 12.4475V18.5875C1 20.7975 2.79 22.5875 5 22.5875H8C8.55 22.5875 9 22.1375 9 21.5875V14.9175C9 13.8175 9.9 12.9175 11 12.9175H13C14.1 12.9175 15 13.8175 15 14.9175V21.5875C15 22.1375 15.45 22.5875 16 22.5875H19C21.21 22.5875 23 20.7975 23 18.5875V12.4475C23 11.0375 22.41 9.6975 21.36 8.7475Z',
    },
  ],
};
